<script src="../../router/index.js"></script>
<template>
    <b-container>
        <b-col v-if="!showVerifonePaymentModal">
            <span class="payment-form-title">{{ campaign.organization.name }}</span>
            <span class="payment-form-title">{{ campaign.name }}</span>

            <div v-if="!showingLogin">
                <b-row class="mt-3 d-flex flex-row align-items-center">
                    <b-col>
                        <div>
                            <span class="fair-tab-info-text">Kertalahjoituksen voit tehdä rekisteröitymättä.</span>
                            <b-button
                                class="col-12 mt-2 fair-tab align-bottom payment-option-button"
                                v-bind:class="{ active_option_button: activeTab === 2 }"
                                @click.stop="setView(2)"
                            >
                                {{ $t("payment.single_donation") }}
                            </b-button>
                        </div>
                    </b-col>
                    <b-col>
                        <div>
                            <span class="fair-tab-info-text clickable-link">
                                Kuukausilahjoitus vaatii kirjautumisen.
                            </span>
                            <b-button
                                class="col-12 mt-2 fair-tab align-bottom payment-option-button"
                                v-bind:class="{ active_option_button: activeTab === 1, 'hover-gray': !$store.state.user }"
                                @click.stop="setView(1)"
                            >
                                {{ $t("payment.monthly_donation") }}
                            </b-button>
                        </div>
                    </b-col>
                </b-row>

                <div v-if="activeTab !== 1 || activeTab === 1 && $store.state.user"  >
                    <b-row>
                        <b-col sm="12" class="mt-3">
                            <div class="center">
                                <b-button
                                    :disabled="loading"
                                    v-for="preset in this.presetAmounts"
                                    :key="preset.id"
                                    class="payment-price-button"
                                    :pressed="amount && amount === preset.amount / 100"
                                    @click.stop="selectPreset(preset)"
                                >
                                    {{ getPlanString(preset) }}
                                </b-button>
                            </div>
                        </b-col>
                    </b-row>

                    <b-row class="nopads">
                        <b-col sm="2"></b-col>
                        <b-col sm="8" class="mt-3">
                            <b-form-group>
                                <b-form-input
                                    id="amount"
                                    v-model="amount"
                                    type="number"
                                    step=".1"
                                    size="mb"
                                    min="5"
                                    max="5000"
                                    v-bind:placeholder="this.$t('payment.other_amount_to_be_donated')"
                                />
                            </b-form-group>
                        </b-col>
                        <b-col cols="2" class="nopads mt-2 pt-3">
                            <span class="fair-tab-info-text" style="font-size: 1.7em">€</span>
                        </b-col>
                    </b-row>
                </div>

                <b-row v-if="activeTab === 1 && !$store.state.user">
                    <b-col sm="12" class="mt-4 text-center">
                        {{ $t("payment.sign_in_to_donate") }}
                        <div class="col-12 nopads pt-2 fair-link" @click.stop="showLogin">
                            {{ $t("payment.sign_in") }}
                        </div>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col sm="12" class="text-center mt-3">
                        <b-button v-if="activeTab !== 1 || activeTab === 1 && $store.state.user" class="to-payment-button" :disabled="loading || amount < 5" @click.stop="handleDonation">
                            {{ $t("payment.proceed_to_payment") }}
                        </b-button>
                    </b-col>
                </b-row>
            </div>

            <login v-if="showingLogin" @loginUser="hideLogin" @close="hideLogin" @alert="showAlert">
            </login>
        </b-col>

        <div v-if="showVerifonePaymentModal">
            <div class="text-center mb-3">
                <span class="payment-form-title">{{ campaign.organization.name }}</span>
                <span class="payment-form-title">{{ campaign.name }}</span>
                <span class="fair-tab-info-text" style="font-size: 1.7em">{{ amount }} €</span>
            </div>
            <payment-form-verifone
                :campaignId="campaign.id"
                :amount="amount ? Number(amount) : 0"
                @update:amount="amount = $event"
                :userFirstName="$store.state.user ? $store.state.user.firstName : undefined"
                :userLastname="$store.state.user ? $store.state.user.lastName : undefined"
                :userEmail="$store.state.user ? $store.state.user.email : undefined"
                :userPhoneNumber="$store.state.user ? $store.state.user.phonenumber : undefined"
                :userId="$store.state.user ? $store.state.user.id : undefined"
                :isMonthlyDonation="activeTab === 1"
            />
        </div>

        <div v-if="loading" id="loader" class="spinner" />
    </b-container>
</template>


<script>
import FairApi from "../../modules/api";
import Login from "../Login";
import OnetimeOffSessionPayment from "./OnetimeOffSessionPayment";
import SubscriptionOffSessionPayment from "./SubscriptionOffSessionPayment";
import PaytrailPaymentMethods from "./PaytrailPaymentMethods.vue";
import PaymentFormVerifone from "./PaymentFormVerifone.vue";

export default {
    name: "payment-form",
    components: {
        Login,
        OnetimeOffSessionPayment,
        SubscriptionOffSessionPayment,
        PaytrailPaymentMethods,
        PaymentFormVerifone
    },
    data() {
        return {
            isLoginVisible: false,
            stripe: null,
            loading: false,
            activeTab: 2,
            showLoginForm: false,
            onetimeOffSessionPayment: false,
            subscriptionOffSessionPayment: false,
            showSinglePaymentMethods: false,
            showingLogin: false,
            showVerifonePaymentModal: false,
            sessionId: null,
            amount: 10,
            MAX_AMOUNT: 5000,
            MIN_AMOUNT: 5,
            onetimePayment: false,
            selectedPlan: null,
            paymentMethods: null,
            subscription: null,
            presetAmounts: [
                { id: 0, amount: 1000 },
                { id: 1, amount: 2000 },
                { id: 2, amount: 3000 },
                { id: 3, amount: 4000 },
                { id: 4, amount: 5000 }
            ]
        };
    },

    props: {
        campaign: {
            type: Object,
            required: true
        }
    },

    created() {
        this.setView(2);
    },

    computed: {
        sortedPlans() {
            let plans = this.campaign.product.plans;
            return plans.sort(function(a, b) {
                return a.amount - b.amount;
            });
        }
    },

    methods: {
        showLogin() {
            this.showingLogin = true; // Open login modal
        },

        fetchSubscriptionSuccess: function(response) {
            this.subscription = response;
            this.fetchPaymentMethods();
        },

        fetchFailed: function() {
            this.loading = false;
        },

        fetchPaymentMethods: function() {
            if (this.$store.state.token) {
                FairApi.get(FairApi.paymentMethod(), this.fetchPaymentMethodsSuccess, this.fetchFailed);
            }
        },

        fetchPaymentMethodsSuccess: function(response) {
            this.loading = false;
            this.paymentMethods = response;
        },

        showAlert(text) {
            this.$emit("alert", text);
        },


        hideLogin() {
            this.showingLogin = false;
        },

        handleDonation: function() {
            if (this.amount > 0) {
                this.showVerifonePaymentModal = true;
            }
        },
        getPlanString: function(plan) {
            return plan.amount / 100 + "€"; // + this.$tc("payment.per_month", plan.currency)
        },

        selectPlan: function(plan) {
            this.selectedPlan = plan;
        },

        selectPreset: function(preset) {
            this.amount = preset.amount / 100;
        },

        alreadySubscribed: function() {
            return this.subscription && this.subscription.length > 0;
        },

        setView(tab) {
            this.activeTab = tab;
            if(tab === 1 && this.amount < 10) {
                this.amount = 10;
            }
        }
    }
};
</script>